import { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import UtilsFormule from "../../../utils/UtilsFormule";

const DataTableListInventaire = ({ listInventaire }) => {
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  function handleTableChange({ products }) {
    return products;
  }

  const addPayementHandler = (id) => {
    localStorage.setItem("idInvntaireWarehouse", id);
    const pdfWindow = window.open();
    pdfWindow.location.href = "/detailsInventaire";
  };

  function detailsFormatter(cell, row) {
    return (
      <button
        title="Voir le détail de l'inventaire"
        className="btn btn-sm btn-outline-dark"
        style={{ width: 36 }}
        onClick={() => addPayementHandler(row.id)}
      >
        <i className="fas fa-folder-open"></i>
      </button>
    );
  }

  function refInventaireFormatter(cell, row) {
    return (
      <span>
        {row.ref}-{row.year}
      </span>
    );
  }

  function creationDateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDate(row.creationDate)}</span>;
  }
  function refWarehouseFormatter(cell, row) {
    return (
      <span>
        {row.refWarehouse}-{row.nameWarehouse}
      </span>
    );
  }

  const columns = [
    {
      dataField: "ref",
      text: "Reférence",
      formatter: refInventaireFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "id",
      text: "Dépôt ",
      formatter: refWarehouseFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "id",
      text: "DC ",
      formatter: creationDateFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "id",
      text: "Plus",
      formatter: detailsFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
  ];
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
 

  return (
    <section className="content ">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-12">
            <div
              className="card card-outline card-dark"
              style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
            >
              <div className="card-header">
                <h3 className="card-title">
                  <i className="fas fa-clipboard-list mr-2"></i>Les inventaires
                  <span className="badge badge-dark ml-2">
                    {listInventaire.length}
                  </span>
                </h3>
              </div>
              <div className="card-body">
                <ToolkitProvider
                  keyField="id"
                  data={listInventaire}
                  columns={columns}
                  onTableChange={handleTableChange}
                  exportCSV
                  search
                >
                  {(props) => (
                    <div>
                      <div className="row ml-0">
                        <div>
                          <SearchBar
                            {...props.searchProps}
                            className="custome-search-field"
                            style={{ color: "black" }}
                            placeholder="Chercher"
                          ></SearchBar>
                        </div>
                        <div className="ml-auto mr-0">
                          <MyExportCSV {...props.csvProps}></MyExportCSV>
                        </div>
                      </div>
                      <div className="row">
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={paginationFactory(options)}
                          headerClasses="thead-light"
                          wrapperClasses="table-responsive w-100"
                          striped
                          hover
                          condensed
                          //   expandRow={expandRow}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
              {openInfoAlert && (
                <Snackbar
                  open={openInfoAlert}
                  autoHideDuration={2000}
                  onClose={handleInfoClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                  <Alert
                    variant="filled"
                    onClose={handleInfoClose}
                    severity="info"
                  >
                    {infoAlertText}
                  </Alert>
                </Snackbar>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default DataTableListInventaire;
